import { render, staticRenderFns } from "./ChargesDetails.vue?vue&type=template&id=012134c6&scoped=true"
import script from "./ChargesDetails.vue?vue&type=script&lang=js"
export * from "./ChargesDetails.vue?vue&type=script&lang=js"
import style0 from "./ChargesDetails.vue?vue&type=style&index=0&id=012134c6&lang=scss"
import style1 from "./ChargesDetails.vue?vue&type=style&index=1&id=012134c6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012134c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('012134c6')) {
      api.createRecord('012134c6', component.options)
    } else {
      api.reload('012134c6', component.options)
    }
    module.hot.accept("./ChargesDetails.vue?vue&type=template&id=012134c6&scoped=true", function () {
      api.rerender('012134c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popups/charges-details/ChargesDetails.vue"
export default component.exports